// extracted by mini-css-extract-plugin
export var icon = "menu-button-module--icon--30Yei";